// Global instance manager for Foxit PDFUI 7.5
let _pdfuiInstance = null;
let _defaultContainer = null;

export const initializeFoxit = () => {
  if (!window.UIExtension || _pdfuiInstance) {
    return;
  }

  // Create a hidden container for initialization
  _defaultContainer = document.createElement('div');
  _defaultContainer.id = 'foxit-default-container';
  _defaultContainer.style.display = 'none';
  document.body.appendChild(_defaultContainer);

  const libPath = "/lib/";
  _pdfuiInstance = new window.UIExtension.PDFUI({
    viewerOptions: {
      libPath,
      jr: {
        licenseSN: "hUVuzlvzrAvtYRvzLCORw2+5Iy873z7YlLXOEdqQibBEcSPoz91umA==",
        licenseKey: "PjwcmTawMSysb7uJGyG8Al+PlhAEkpdTk+VkGKFsjqe5rsbZ1SoWBWFuQ0qZUOLydAIcXlccljHNvaSxVWc/k0kh87Kp4BDNFBqX7X+URtXfx6DKDeEKX26kDQ8V6pnSwxZiVmtDo5A2XcgjEVHdqePd3IO1aZtaFK9QLAnOgi7Ni2cM6WIJoohdh/Q7nn9UNH6cUfOHvzdd9vCsueB/sdEgsZrfKJkuP49MTLlC+bQrp7I0Vce2ChxtoSH4XwTKA/gLT3z4dPpWiW/PGTvQibodPEfPl+8s1gx10AkzR9vbVCki9OeVOlsY0sq6UJuHnhzaRJmhByLnVXeDqIFO1fdQvmpBiFfdDEkAQW/nG5nezs9mOaEjhy0bgdtjUil3RNZtJzXbbJ9Z0fBAf3epATZI8r0N7jn8wg8wzCBkiFfLEMrtZQU4dgwHLTdD7W32CClXB/r8cTIEPVjYliD4RTXPPSyvHnzrm3lsXsuL78h+/hqeOPnnqGnAQLOA+QF0a/i21H2FJ8UAp0Qa2JZaJxB+Pc6TDuaacSG0a7VW+WoBSeanS3shfrbDZIeuMjTvy4w3QGwmPAsbNaRfXXgO4CGc1n/+rQe6iK2N3tlYyfyG1nk2rpxcaEW9Ls2EV6HPbh1gja/R0MjZN7TfP8r6EOpeXDtx7Nqx/zAx8TqPMoSnlFehD57UvEqAR5T97zkOLLBz1yGTQXraN07dML6GYRDFZstzI41G+vnBQpBBsEIJ7DUqeFz/0MKpFBgOktxH9HFsxroya+1re1W9/4q/STkq8e4LyohBq347Beb0RnvJTzgyqC7bG1AIx8T9sC4xCKdSpRCZ06TRBQ8bnU4DTj6yhaBruwtLRF9EXvygLb9Q2XwedpHTiWqS9iZvo+DiCFb8uxAt+lgo+pF2pk1oeqowMMDzrnsW1ZY4fc35EGPo+PuCaM7r60AdWhGOiEts2KtmVdwXEw8+sSytZgpwKBeo8tbtx0f7S+f1n0ezEVsbU/FEoOEu9/ox192H2vF3UV8xNcr0DGbtVz9ewKbn3QHiXAVRdQe+ri0EP+Bj3nM37ZPOtKsoSEmeddThsjHQ+xsw8FwUpN/9FxGMpth+b6OkzaVutpIaiHBX9AczbMQLrCZ+2zH3a6oFJJHfr5teCw8Hse2GxHTHNv+PlKJy2Brxgpb8GuM6Eesmd2uLgm0ss0AvQDRwAq+lCdQ=",
      },
    },
    renderTo: _defaultContainer, // Use the hidden container
  });

  return _pdfuiInstance;
};

export const getFoxitInstance = () => {
  return _pdfuiInstance;
};

// Change render target for existing instance
export const setRenderTarget = async (element) => {
  if (!_pdfuiInstance) {
    return null;
  }
  
  try {
    const viewer = await _pdfuiInstance.getPDFViewer();
    
    // If element is null, render back to hidden container
    const targetElement = element || _defaultContainer;
    
    // Hide previous container if it's our default one
    if (_defaultContainer && _defaultContainer.style.display === 'block') {
      _defaultContainer.style.display = 'none';
    }
    
    await viewer.renderTo(targetElement);
    
    // Show target element if it's our default container
    if (targetElement === _defaultContainer) {
      _defaultContainer.style.display = 'block';
    }
    
    return _pdfuiInstance;
  } catch (error) {
    console.error('Error setting render target:', error);
    return null;
  }
};

// Clean up instance if needed
export const destroyFoxitInstance = async () => {
  if (_pdfuiInstance) {
    try {
      await _pdfuiInstance.destroy();
      _pdfuiInstance = null;
      
      // Remove the default container
      if (_defaultContainer && _defaultContainer.parentNode) {
        _defaultContainer.parentNode.removeChild(_defaultContainer);
        _defaultContainer = null;
      }
    } catch (error) {
      console.error('Error destroying Foxit instance:', error);
    }
  }
}; 